class CacheNode {
  constructor({ key = "default", next = null, prev = null }) {
    this.key = key;
    this.next = next;
    this.prev = prev;
  }
}
export default CacheNode;
